
import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * Normalized pin row item shape:
 *   key:            string  - unique row key
 *   userId?:        string  - owner of the pin (cross-user list, otafiles page)
 *   deviceSerial:   string | null  - null = user-scope (all devices)
 *   otaFileId:      number  - so the form can pre-fill on "update"
 *   appVersion:     string  - pinned app version
 *   wirelessVersion?: string  - pinned wireless version (optional)
 *   reason?:        string  - why pinned
 *   setBy?:         string  - admin who set the pin
 *   createdAt:      Date | string
 *   userEmail?:     string  - shown only when listing across users (otafiles page)
 */
export interface PinListItem {
  key: string
  userId?: string | null
  deviceSerial: string | null
  otaFileId: number
  appVersion: string
  wirelessVersion?: string | null
  reason?: string | null
  setBy?: string | null
  createdAt: Date | string
  userEmail?: string | null
}

@Component({ name: 'PinList' })
export default class PinList extends Vue {
  @Prop({ type: Array, default: () => [] }) pins!: PinListItem[]
  @Prop({ type: Boolean, default: true }) removable!: boolean
  // Set to the row's key when delete is in-flight to surface a spinner on the
  // right button without blocking other rows.
  @Prop({ type: String, default: null }) removingKey!: string | null

  private formatRelative(date: Date | string): string {
    if (!date) return ''
    const d = typeof date === 'string' ? new Date(date) : date
    const ms = Date.now() - d.getTime()
    const days = Math.floor(ms / 86400000)
    if (days < 1) return this.$t('otaPin.today') as string
    if (days < 2) return this.$t('otaPin.yesterday') as string
    if (days < 7) return this.$t('otaPin.daysAgo', { n: days }) as string
    if (days < 30) return this.$t('otaPin.weeksAgo', { n: Math.floor(days / 7) }) as string
    if (days < 365) return this.$t('otaPin.monthsAgo', { n: Math.floor(days / 30) }) as string
    return d.toLocaleDateString('tr-TR')
  }
}
